@import '@hevoio/hevo-ui-toolkit/styles/variables';

.cardList {
  display: flex;
  flex-direction: column;
  gap: $spacer-12;
  width: 100%;
  padding: $spacer-4 0;
}
